// Invite outcome screens (docs/miniapp-m4-tz.md §3.6–3.8). Faithful to the
// prototype (screens-auth.jsx · AuthInviteOutcome): a centered tone-colored
// badge + title/body + one CTA. Three variants:
//   expired  → ⏰ warning, CTA closes the app
//   invalid  → 🚫 danger,  CTA closes the app
//   connected→ ✓ success,  CTA enters the app (continueAfterInvite)
import { useAuth } from '../../auth/AuthProvider'
import { getWebApp } from '../../telegram/tg'
import { Button, Icon, t } from '../../design'

type Kind = 'expired' | 'invalid' | 'connected'

const TONE: Record<Kind, { bg: string; fg: string }> = {
  expired: { bg: 'var(--warning-bg)', fg: 'var(--warning)' },
  invalid: { bg: 'var(--danger-bg)', fg: 'var(--danger)' },
  connected: { bg: 'var(--success-bg)', fg: 'var(--success)' },
}

function closeApp() {
  try { getWebApp()?.close() } catch { /* noop outside Telegram */ }
}

function InviteOutcome({ kind, onCta }: { kind: Kind; onCta: () => void }) {
  const tone = TONE[kind]
  const icon = kind === 'expired' ? <Icon.Clock size={32} sw={2} />
    : kind === 'invalid' ? <Icon.AlertTri size={32} sw={2} />
      : <Icon.Check size={32} sw={2} />
  return (
    <div className="scroll-y" style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', gap: 18, padding: '20px 16px' }}>
      <div style={{ textAlign: 'center' }}>
        <span style={{ width: 72, height: 72, borderRadius: 20, background: tone.bg, color: tone.fg, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', marginBottom: 14 }}>
          {icon}
        </span>
        <div className="t-h1" style={{ marginBottom: 6 }}>{t(`inv.${kind}.title`)}</div>
        <div className="t-caption" style={{ maxWidth: 290, margin: '0 auto', lineHeight: 1.5 }}>{t(`inv.${kind}.body`)}</div>
      </div>
      <Button
        variant={kind === 'connected' ? 'primary' : 'secondary'}
        full
        icon={kind === 'connected' ? <Icon.ArrowRight size={16} sw={2.25} /> : undefined}
        onClick={onCta}
      >
        {t(`inv.${kind}.cta`)}
      </Button>
    </div>
  )
}

export function InviteExpiredScreen() {
  return <InviteOutcome kind="expired" onCta={closeApp} />
}

export function InviteInvalidScreen() {
  return <InviteOutcome kind="invalid" onCta={closeApp} />
}

export function AlreadyConnectedScreen() {
  const { continueAfterInvite } = useAuth()
  return <InviteOutcome kind="connected" onCta={continueAfterInvite} />
}
